import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib";
import {
  BudgetStatusEnum,
  RequestBudgetResponse,
  UpdateBudgetStatusRequestDTO,
} from "@/types";

async function updateBudgetStatus({
  id,
  status = BudgetStatusEnum.APPROVED,
}: UpdateBudgetStatusRequestDTO): Promise<RequestBudgetResponse> {
  const response = await httpRequest.put<RequestBudgetResponse>(
    `/budgets/${id}/update-status`,
    { status }
  );
  return response.data;
}

export function useUpdateBudgetStatusMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateBudgetStatus,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["budgets"] });
    },
  });
}
